import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Box from "@material-ui/core/Box";
import MyGallery from "./ImageGallery";
import {
  getInspectionVehicleDetails,
  getVehicleSaleInfoByVin,
  getPurchaseReceipt,
} from "../service/api";
import moment from "moment";
import Loaderpage from "./LoaderPage";
import { convertBase64ToArray, generateFileUrl } from '../Utils/utils';

export default function AdminDetailedReport(props) {
  const vin = props?.vin;
  const groundingId = props?.groundingId;
  const isUnground = props?.isUnground;
  const [groundingDetails, setGroundingDetails] = useState(props?.inspectiondata);
  const [inspectionVehicleDetails, setInspectionVehicleDetails] = useState(null);
  const [vehicleSalesInfo, setVehicleSalesInfo] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState('');

  useEffect(() => {
    setPageLoading(false);
    getInspectionVehicleDeta();
    getVehicleSaleInformation();
    purchaseReceipt(vin);
  }, [vin]);

  async function getInspectionVehicleDeta() {
    let apiResponse = await getInspectionVehicleDetails(vin,groundingId);
    if (apiResponse && apiResponse?.data) {
      setInspectionVehicleDetails(apiResponse?.data);
    }
  }

  async function getVehicleSaleInformation() {
    let apiResponse = await getVehicleSaleInfoByVin(vin,groundingId);
    if (apiResponse && apiResponse?.data) {
      setVehicleSalesInfo(apiResponse?.data);
    }
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })

  const getCurrentPayOffValue = (groundingDetailsValue) => {
    let currentPayOff;
    if (groundingDetailsValue?.currentStatus) {
      if(groundingDetailsValue?.currentStatus.indexOf('Sold') >= 0 || groundingDetailsValue?.currentStatus.indexOf('transportation') >= 0) {
        currentPayOff = 'NA'
      } else {
        currentPayOff = groundingDetails?.currentPayoffAmount && formatter.format(groundingDetails?.currentPayoffAmount);
      }
    }
    return currentPayOff;
  }
  
  const milesFormatter = new Intl.NumberFormat('en-US');
  const getGroundingDetailsCurrentStatus = currentStatus => {
    let currentStatusValue = currentStatus;
    if(currentStatusValue) {
      if(currentStatusValue?.indexOf('_') >= 0) {
        currentStatusValue = currentStatusValue?.replaceAll('_', ' ');
      }
      if(currentStatusValue?.indexOf('/') >= 0) {
        currentStatusValue = currentStatusValue?.replaceAll('/', ' ');
      }
    }
    return currentStatusValue?.toLowerCase();
  }
  
  const purchaseReceipt = async (vin) => {
    const purchaseReceiptData = await getPurchaseReceipt(vin,groundingId);
    const success = purchaseReceiptData?.data?.success;
    if(typeof success === 'string' && success?.toLowerCase() === 'true' )
    {
    console.log('purchaseReceiptData', purchaseReceiptData)
    var sampleArr = convertBase64ToArray(purchaseReceiptData?.data?.receiptByte);
    setPdfUrl(generateFileUrl(sampleArr,"application/pdf"));
    }
  }

  const getRelevantGroundingId = (previousGroundingList, currentGroundingId) => {
    const latestGroundingId = groundingDetails?.groundingId;
    if(!currentGroundingId){
      return latestGroundingId;
    }
    if (!previousGroundingList || previousGroundingList.length === 0) {
      return null;
    }
    const sortedList = previousGroundingList.length > 1 ? [...previousGroundingList].sort(
      (a, b) => new Date(b.ungroundingDate) - new Date(a.ungroundingDate)
    ) : previousGroundingList;
    const index = sortedList.findIndex(item => item["groundingId"] === Number(currentGroundingId));
    if(index !== -1 && index + 1 < sortedList.length){
      return previousGroundingList[index + 1]["groundingId"];
    }
    else if(index === -1){
      return previousGroundingList[0]["groundingId"];
    }
    return null;
  };

  const showPreviousGrounding = (vinSearch, groundingId) => {
    {
      const gId = localStorage.getItem("groundingId");
      if (vinSearch && vinSearch?.length === 17) {
        const dataObj = {
          vin: vinSearch,
          groundingId : groundingId
        };
        const params = new URLSearchParams(dataObj).toString();
        const prefix = window.location.href && window.location.href.split('/');
        const nextUrl = window.location.href.replace(prefix[prefix?.length - 1], `groundingHistory?${params}`);
        window.open(`${nextUrl}`, '_blank');
        
      }
    }
  }

  return (
    <div className={isUnground ? "ungroundConditionPageCard" : "conditionPageCard"}>
      <Box pt={5}>
        <Grid container spacing={3} className= {isUnground ? "ungroundConditionCardReportSpace" : "ConditionCardReportSpace"}>
          <Grid item md={12}>
            <Box display={"flex"} alignItems={"center"}>
              <Box className="resultForVin">{isUnground ? "Vehicle Summary for VIN: " : "Results for VIN: "} {vin}</Box>
            </Box>
          </Grid>
          {(pageLoading) ? <div className="loadingSpinneradminReportSearch"><Loaderpage /></div> : (true) ? (<><Grid item xs={5}>
            <div className="codereportimggallery">
              {inspectionVehicleDetails &&
                inspectionVehicleDetails?.inspection_mileage ? (
                <MyGallery {...inspectionVehicleDetails} />
              ) :
                (<><Grid>
                  <div className="imageReportSection">
                    <img src="TMZ.png" alt="Mazda Logo" width="100%" />
                  </div>
                </Grid></>
                )}
            </div>
          </Grid><Grid item xs={7}>
              <div className="ConditionReportSection">
                <div className="reportTitle">
                  <span>
                    {groundingDetails && groundingDetails?.model_year}{" "}
                    {groundingDetails && groundingDetails?.brand}{" "}
                    {groundingDetails && groundingDetails?.model}{" "}
                    {groundingDetails && groundingDetails?.ext_color}{" "}
                  </span>
                </div>
                {inspectionVehicleDetails && (
                  <div style={{ "width": "16rem" }}>
                    {" "}
                    {inspectionVehicleDetails?.inspection_mileage ? (
                      <span className="ConditionReportInspection">
                        <span className="BadgeValue">Inspection Complete</span>
                      </span>
                    ) : (
                      <span className="ConditionReportInspectionPending">
                        <span className="BadgeValue">Inspection Pending</span>
                      </span>
                    )}{" "}
                  </div>
                )}
              </div>

              <Grid container spacing={3}>
                <Card className="vehicleSectionCR">
                  <Typography variant="h6">Grounding Details</Typography>
                  <hr />
                  <CardContent>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Account Number </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {" "}
                          {groundingDetails?.accountNumber}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Current Status </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span style={{ textTransform:'capitalize' }} className="textSize">
                          {" "}
                          {groundingDetails?.currentStatus && getGroundingDetailsCurrentStatus(groundingDetails?.currentStatus)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Customer Return Date </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.customerReturnDate &&
                            moment(groundingDetails?.customerReturnDate).format(
                              "MM/DD/YYYY"
                            )}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Grounding Dealer Number
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.groundingDealerNumber}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Grounding Dealer Name</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.groundingDealerName}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Grounding Date</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.groundingDate &&
                            moment(groundingDetails?.groundingDate).format(
                              "MM/DD/YYYY"
                            )}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Grounding Mileage </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.groundingMileage && `${milesFormatter.format(groundingDetails?.adjMileage ? groundingDetails?.adjMileage : groundingDetails?.groundingMileage)} MI`}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Transportation Order Date
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.transportationOrderedDate &&
                            moment(
                              groundingDetails?.transportationOrderedDate
                            ).format("MM/DD/YYYY")}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Transportation Company</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.transportationCompany}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Bankruptcy Code </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.bankruptcyCode}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Term Code </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.termCode}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Dealer Exclusivity Expire Date
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.dealerExclusivityExpireDate &&
                            moment(
                              groundingDetails?.dealerExclusivityExpireDate
                            ).format("MM/DD/YYYY")}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Type </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">{groundingDetails?.type}</span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Residual </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.residual && formatter.format(groundingDetails?.residual)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Current Payoff Amount</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails && getCurrentPayOffValue(groundingDetails)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Payoff at Grounding </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.payoffAtGrounding && formatter.format(groundingDetails?.payoffAtGrounding)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Grounding Dealer Auction
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.groundingDealerAuction}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Total Outstanding Remaining Payments
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.currentTotalOutstandingRemainingPayments && formatter.format(groundingDetails?.currentTotalOutstandingRemainingPayments)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Number Of Guaranteed Payments </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.guaranteedPayments}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Payment Guarantee Amount</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.paymentGuarantee && formatter.format(groundingDetails?.paymentGuarantee)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            10-Day Rule No Charge Amount
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.currentMonthlyPayments && formatter.format(groundingDetails?.currentMonthlyPayments)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Market Based Price </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.marketBasedPrice && formatter.format(groundingDetails?.marketBasedPrice)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Remaining Payments at Grounding
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.remainingPaymentsAtGrounding && formatter.format(groundingDetails?.remainingPaymentsAtGrounding)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                           Number Of Remaining Payments at Grounding
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {groundingDetails?.remainingPaymentsAtGroundingCount}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                           Previous Grounding Id
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                        {getRelevantGroundingId(groundingDetails?.previousGroundingList, groundingId ? groundingId : groundingDetails?.groundingId) ? <a href= {window.location.href} target = "_blank" className="vin" rel="noopener noreferrer"
                         onClick={(e) => {
                          e.preventDefault();
                          showPreviousGrounding(vin,getRelevantGroundingId(groundingDetails?.previousGroundingList,groundingId ? groundingId : groundingDetails?.groundingId));
                        }
                      }
                        >{getRelevantGroundingId(groundingDetails?.previousGroundingList, groundingId ? groundingId : groundingDetails?.groundingId)}</a> : <span>NA</span>}
          
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                  </CardContent>

                  <Typography variant="h6">Inspection Details</Typography>
                  <hr />
                  <CardContent>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Inspection Scheduled Date
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.inspection_req_date &&
                            moment(
                              inspectionVehicleDetails?.inspection_req_date
                            ).format("MM/DD/YYYY")}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Inspection Date </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.inspection_date &&
                            moment(
                              inspectionVehicleDetails?.inspection_date
                            ).format("MM/DD/YYYY")}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Inspection Status </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.inspection_status}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Inspection Mileage </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.inspection_mileage && `${milesFormatter.format(inspectionVehicleDetails?.inspection_mileage)} MI`}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Master Keys Returned </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.keys?.keys}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Valet Keys Returned </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.keys?.valet}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Smart Keys Returned </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.keys?.smartKey}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Remote Keys Returned </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.keys?.remotes}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold"> Inspection Type </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {inspectionVehicleDetails?.inspection_type}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">
                            Excess Wear & Use Amount
                          </span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                            {inspectionVehicleDetails?.ewu && formatter.format(inspectionVehicleDetails?.ewu)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                  </CardContent>
                  <Typography variant="h6">Purchase Details</Typography>
                  <hr />
                  <CardContent>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Sold Date</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {vehicleSalesInfo?.sale_date &&
                            moment(vehicleSalesInfo?.sale_date).format(
                              "MM/DD/YYYY"
                            )}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Purchasing Dealer</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {vehicleSalesInfo?.dealer_name}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Purchase Dealer Number</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {vehicleSalesInfo?.dealer_number}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Purchase Type</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {vehicleSalesInfo?.price_category}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Gross Purchase Amount</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <span className="textSize">
                          {vehicleSalesInfo?.total_sale_amount && formatter.format(vehicleSalesInfo?.total_sale_amount)}
                        </span>
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Purchase Receipt</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                      {(vehicleSalesInfo?.sale_date && pdfUrl!=='') && <a download='PurchaseReceipt' href={pdfUrl} >Download</a>}
                      </ListItemSecondaryAction>
                    </List>
                    <List className="paddingCSS">
                      <ListItemText>
                        <span className="textStyle">
                          <span className="textBold">Purchase Venue</span>
                        </span>
                      </ListItemText>
                      <ListItemSecondaryAction>
                      <span>{vehicleSalesInfo?.sale_process_stage}</span>
                      </ListItemSecondaryAction>
                    </List>
                  </CardContent>
                  <div className="disclaimerVRS">
                    Disclaimer: The parts, equipment, accessories, and other
                    information listed above are based on equipment/configuration
                    at the time vehicle was sold by Mazda Motor Corporation to a
                    dealer and does not mean that this vehicle is still so
                    equipped.
                  </div>
                </Card>
              </Grid>
            </Grid></>):(<div className="listingPageCardNoData" style={{ paddingLeft: '25%', paddingBottom: '16%' }}>
          <img src="noDataFound.jpeg" alt="nodata" className="nodataImage" />
          <span className="nodataText">VIN Not Found</span>
        </div>)}
        </Grid>
      </Box>
    </div>
  );
}
